import { withStyles } from '@material-ui/core';
import LoadingContainer from './LoadingContainer';
import styles from './LoadingContainer.styles';

export default withStyles(styles)(LoadingContainer);
